import { render, staticRenderFns } from "./NewItemsManager.vue?vue&type=template&id=6cd298f3&scoped=true&"
import script from "./NewItemsManager.vue?vue&type=script&lang=js&"
export * from "./NewItemsManager.vue?vue&type=script&lang=js&"
import style0 from "./NewItemsManager.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NewItemsManager.vue?vue&type=style&index=1&id=6cd298f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd298f3",
  null
  
)

component.options.__file = "NewItemsManager.vue"
export default component.exports